import { Hub, Project } from '@bimone/bimtrack-core';
import { createTransform } from 'redux-persist';
import { EntitiesPersistDto, HubPersistDto, ProjectPersistDto } from './types';
import { serializeHub, deserializeHub } from './serialization/hubSerialization';
import { serializeProject, deserializeProject } from './serialization/projectSerialization';
import { EntitiesState } from '../types';

export const entitiesTransform = createTransform(
  // Transform state on its way to being serialized and persisted.
  (inboundState: EntitiesState): EntitiesPersistDto => {
    return {
      hubs: inboundState?.hubs?.map(hub => serializeHub(hub) as HubPersistDto),
      projects: inboundState?.projects?.map(project => serializeProject(project) as ProjectPersistDto),
    };
  },
  // Transform state being rehydrated
  (outboundState: EntitiesPersistDto): EntitiesState => {
    // convert mySet back to a Set.
    return {
      hubs: outboundState?.hubs?.map(hub => deserializeHub(hub) as Hub),
      projects: outboundState?.projects?.map(project => deserializeProject(project) as Project),
    };
  },
  { whitelist: ['entities'] }
);
